"use client";

// Imports
import { useEffect, useState } from "react";
import { Accordion } from "@/components/ui/accordion";
import { FilterNav } from "@/components";
import useStore from "@/lib/state";

// Filter Bar
export function FilterColumn({ categories, locations, types }) {
  const {
    activeCategories,
    setActiveCategories,
    activeTypes,
    setActiveTypes,
    activeLocations,
    setActiveLocations,
  } = useStore();

  const { setSearchTerm } = useStore();
  const [searchWord, setSearchWord] = useState();

  useEffect(() => {
    if (searchWord == "") setSearchTerm("");
  }, [searchWord]);

  function handleSubmit(e) {
    e.preventDefault();
    setSearchTerm(searchWord);
  }

  // Render
  return (
    <div>
      <div className="flex-col items-start justify-start hidden p-4 space-y-4 rounded-lg lg:flex bg-white">
        <form onSubmit={handleSubmit} className="flex w-full pb-5">
          <input
            className="h-11 w-full rounded-l-full border-2 border-brand-fawn bg-white pl-3 pr-6 text-base focus:outline-none"
            onChange={(e) => setSearchWord(e.target.value)}
            placeholder="Search..."
            value={searchWord}
            type="text"
          />
          <button
            className="px-4 text-base font-button font-semibold rounded-r-full h-11 bg-button text-button-foreground"
            type="submit"
          >
            Search
          </button>
        </form>
        <Accordion type="single" collapsible className="w-full">
          <FilterNav
            filterName="Categories"
            items={categories}
            setActiveItems={setActiveCategories}
            activeItems={activeCategories}
            asCheckbox
          />
          <FilterNav
            filterName="Types"
            items={types}
            setActiveItems={setActiveTypes}
            activeItems={activeTypes}
            asCheckbox
          />
          <FilterNav
            filterName="Locations"
            items={locations}
            setActiveItems={setActiveLocations}
            activeItems={activeLocations}
            asCheckbox
          />
        </Accordion>
      </div>
    </div>
  );
}
